<template>
    <div class="tab-detail">
        <div class="header">
            <div class="title">Whatsapp Business Channel Detail</div>
            <div class="subtitle">Manage your whatsapp business channel</div>
        </div>

        <a-form>
            <div class="form-wrapper">
                <a-alert message="Webhook Address" type="success">
                    <div slot="description">
                        <div class="webhook-info">
                            <span>
                                <a-icon type="copy" @click="copyWebhookAddress" />
                            </span>
                            <span>{{ getWebhookAddress() }}</span>
                        </div>
                    </div>
                </a-alert>
                <div class="input-wrapper">
                    <label>Channel Name</label>
                    <a-input
                        placeholder="Channel Name"
                        v-model="clone.name"
                        v-validate="'required'"
                        name="channelName"
                    />
                </div>
                <div class="input-wrapper">
                    <label>API Key </label>
                    <a-input
                        placeholder="API Key "
                        v-model="clone.payload.apiKey"
                        v-validate="'required'"
                        name="apiKey"
                    />
                </div>
                <div class="input-wrapper">
                    <label>App ID</label>
                    <a-input placeholder="App ID " v-model="clone.payload.appId" v-validate="'required'" name="appId" />
                </div>
                <div class="input-wrapper">
                    <label>Phone Number (E164 Format)</label>
                    <a-input
                        placeholder="Phone Number (E164 Format). ex: 908501234455"
                        v-model="clone.payload.phoneNumber"
                        v-validate="'required'"
                        name="phoneNumber"
                    />
                </div>
                <div class="input-wrapper">
                    <div class="mt-1 mb-1">
                        <a-switch :checked="!!clone.chatbotStory" @click="toggleChatbot" />
                        <span>👉 Forward to Chatbot</span>
                    </div>

                    <label>Forwarding (Chatbot or Live Agent)</label>
                    <a-select
                        v-model="clone.chatbotStory"
                        :defaultValue="null"
                        notFoundContent="👉 Forward Live Agents"
                        :disabled="!showStories"
                    >
                        <a-select-option
                            v-if="!clone.chatbotStory"
                            :selected="true"
                            :value="null"
                        >
                            👉 Forward Live Agents
                        </a-select-option>

                        <a-select-option
                            :key="story._id"
                            v-for="story in stories"
                            :value="story._id"
                        >
                            {{ story.title }}
                        </a-select-option>
                    </a-select>
                    <div class="input-wrapper">
                        <label>Department Forwarding Rule</label>

                        <div class="mt-1 mb-1">
                            <a-switch :checked="!!clone.forwardDepartment" @click="toggleDepartmentForwardingRule" />

                            <span>👉 Department Forwarding Rule Enabled</span>
                        </div>

                        <a-select v-model="clone.forwardDepartment" :defaultValue="null" v-if="clone.forwardDepartment">
                            <a-select-option :selected="true" value="null">👉Selected Department...</a-select-option>
                            <a-select-option
                                :key="department._id"
                                v-for="department of departments"
                                :value="department._id"
                            >
                                {{ getDepartmentTitle(department) }}
                            </a-select-option>
                        </a-select>
                    </div>
                </div>
            </div>
        </a-form>
        <div class="form-footer">
            <div class="actions">
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                    Update
                </a-button>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import VisibilityChanger from "../../WhatsappV1/VisibilityChanger.vue";
import _ from "lodash";
import log2 from "../../../../utils/log2";
import CONFIG from "../../../../config/config";
import { copyText2Clipboard } from "../../../../utils/utils";
import { mapActions, mapState } from "vuex";

const log = log2("UpdateDetail.vue");
export default Vue.extend({
    name: "UpdateDetail",
    components: { VisibilityChanger },
    props: {
        value: {
            required: true,
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            loading: false,
            showStories: !!this.value.chatbotStory,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            stories: (state) => state.CB.stories,
            subjects: (state) => _.get(state.subject.subjects, "data", []) || [],
            departments: (state) => _.get(state.subject.subjects, "data", []) || [],
        }),
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listChannels: "channel/listChannels",
            listStories: "CB/listStories",
        }),
        toggleChatbot() {
            if (this.showStories) {
                this.clone.chatbotStory = null;
            } else {
                if (this.stories[0]) {
                    this.clone.chatbotStory = this.stories[0]._id;
                }
            }
            this.showStories = !this.showStories;
        },
        getWebhookAddress() {
            return `${CONFIG.SOCKET_URL}/webhook/whatsapp-business-api/gupshup/${this.site._id}/${this.clone._id}`;
        },
        getSubjectTitle(department) {
            const validLangs = Object.keys(department.languageContent);
            const targetLang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
            const key = `languageContent.${targetLang}.name`;
            return _.get(department, key);
        },
        copyWebhookAddress() {
            copyText2Clipboard(this.getWebhookAddress());
            this.$message.success("Webhook address copied to clipboard");
        },
        getDepartmentTitle(department) {
            const validLangs = Object.keys(department.languageContent);
            const targetLang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
            const key = `languageContent.${targetLang}.name`;
            return _.get(department, key);
        },
        toggleDepartmentForwardingRule() {
            if (!!this.clone.forwardDepartment) {
                this.clone.forwardDepartment = null;
            } else {
                if (this.departments[0]) {
                    this.clone.forwardDepartment = this.departments[0]._id;
                }
            }
            this.clone = _.cloneDeep(this.clone);
        },
        handleSave() {
            const isValid = true;
            if (isValid) {
                const payload = this.clone;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success("Channel updated successfully");
                        this.$emit("input", this.clone);
                        this.clone = _.cloneDeep(this.clone);
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error("Failed to update channel");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
    },
    mounted() {
        this.listStories();
    },
    watch: {
        value: {
            handler: function (val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    log("value changed=>", val);
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.tab-detail {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;

    .header {
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;

        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }
}
</style>
